// libs
import { useSelector } from "react-redux";

export const useUserProfile = () => {
  const basicProfileReducer = useSelector((state) => state.basicProfileReducer);
  const { userDetailInformation, ...others } = basicProfileReducer || {};

  return {
    ...others,
    ...userDetailInformation,
  };
};
